import { render } from "./TopicNotes.vue?vue&type=template&id=42eccd97"
import script from "./TopicNotes.vue?vue&type=script&lang=js"
export * from "./TopicNotes.vue?vue&type=script&lang=js"

import exportComponent from "/home/stagingfloretcollegein/staging.floretcollege.in/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__